<template>
  <layout-card-wrap
    v-loading="loading"
    hasSlot>
    <template slot="title">概况</template>
    <summary-list
      :list="list1"
      :span="8" />
    <summary-list
      :list="list2"
      :span="8" />
    <el-divider></el-divider>
    <v-chart
      class="chart"
      :options="line" />
  </layout-card-wrap>
</template>

<script>
import SummaryList from './summary.vue'
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import moment from 'moment'
export default {
  name: 'OverviewData',
  components: { SummaryList, 'v-chart': ECharts },
  data() {
    return {
      loading: true,
      list1: [
        {
          label: '入驻企业(家)',
          value: '0'
        },
        {
          label: '产品种类(种)',
          value: '0'
        },
        {
          label: '需求受理(条)',
          value: '0'
        }
      ],
      list2: [
        {
          label: '快检企业(家)',
          value: '0'
        },
        {
          label: '供应链企业(家)',
          value: '0'
        },
        {
          label: '培训人次(人)',
          value: '0'
        }
      ],
      line: {
        title: {
          text: '最近12个月累计数据'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['入驻企业', '产品种类', '需求受理'],
          bottom: 10
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '入驻企业',
            type: 'line',
            smooth: true,
            data: []
          },
          {
            name: '产品种类',
            type: 'line',
            smooth: true,
            data: []
          },
          {
            name: '需求受理',
            type: 'line',
            smooth: true,
            data: []
          }
        ]
      }
    }
  },
  mounted() {
    this.getbasicdatastat()
  },
  methods: {
    getbasicdatastat() {
      this.loading = true
      this.$store.dispatch('account/getbasicdatastat', {
        payload: {
          beginMonth: moment().format('YYYYMM'),
          endMonth: moment().format('YYYYMM')
        },
        success: (res) => {
          this.loading = false
          const data = res.data
          this.$set(this, 'list1', [
            {
              label: '入驻企业(家)',
              value: data.totalVendorCount
            },
            {
              label: '产品种类(种)',
              value: data.totalProductCount
            },
            {
              label: '需求受理(条)',
              value: data.totalWorkOrderCount
            }
          ])
          this.$set(this, 'list2', [
            {
              label: '快检企业(家)',
              value: data.totalInspectionVendorCount
            },
            {
              label: '供应链企业(家)',
              value: data.totalScmVendorCount
            },
            {
              label: '培训人次(人)',
              value: data.totalTrainingCount
            }
          ])
          const cumulativeStatInfos = data.cumulativeStatInfos
          const xAxis = []
          const series1 = []
          const series2 = []
          const series3 = []
          cumulativeStatInfos.forEach(i => {
            xAxis.push(i.month)
            series1.push(i.vendorCount)
            series2.push(i.productCount)
            series3.push(i.workOrderCount)
          })
          this.line.xAxis.data = xAxis
          this.line.series[0].data = series1
          this.line.series[1].data = series2
          this.line.series[2].data = series3
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.chart {
    width 100%;
    height: 300px;
}
</style>
